// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"wQ-z","inlineTitle":"xQ-z","sponsoredAdsWrapper":"yQ-z","marketplaceRecosWrapper":"zQ-z"};